import { logger } from '@sendpayments/js-utils';
import { isArray } from 'lodash';

export const reduce = (state, action) => {
  const { payload } = action;
  const { entity } = payload || {};

  if (!payload) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/UPDATE_ENTITY. payload need to be passed`, action);
  }

  if (!entity) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/UPDATE_ENTITY. entity need to be passed`, action);
  }

  const { id, updatedAt, createdAt } = entity || {};

  if (isArray(entity)) {
    logger.error(
      '@sendpayments/react-shared/remote-data',
      `reducer/UPDATE_ENTITY. the payload entity is an array. we are SKIPPING this update.`,
      {
        action,
      },
    );
    // we cannot update an entity that is an array, we would loose all the data.
    return state;
  }

  const timestamp = updatedAt || createdAt ? +new Date(updatedAt || createdAt) : undefined;

  let somethingHasChanged = false;

  const newState = Object.entries(state).reduce((acc, [prop, remoteData]) => {
    const { loading, failed, data, initialized } = remoteData;

    if (initialized && !failed && !loading) {
      let findEntity;

      // data can be an object or an array
      if (data) {
        if (isArray(data)) {
          findEntity = data.find(({ id: listItemId }) => listItemId === id);
        } else {
          findEntity = data.id === id ? data : undefined;
        }
      }

      if (findEntity) {
        logger.log('@sendpayments/react-shared/remote-data', `reducer/UPDATE_ENTITY. updating list ${prop} for id ${id}`, action);

        const updatedEntity = {
          ...payload.entity,
        };

        somethingHasChanged = true;

        // update the list with the new entity
        acc[prop] = {
          loading: false,
          data: isArray(data) ? [...data.filter(({ id: listItemId }) => listItemId !== id), updatedEntity] : updatedEntity,
          initialized: true,
          invalidate: false,
          failed: false,
          offline: false,
          fetching: false,
          lastUpdated: timestamp,
          fetched: remoteData.fetched,
        };

        return acc;
      }
    }

    acc[prop] = remoteData;
    return acc;
  }, {});

  return somethingHasChanged ? newState : state;
};
